import { OpenInFullSharp as OpenInFullSharpIcon, CloseFullscreenSharp as CloseFullscreenSharpIcon,ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardHeader, Checkbox, IconButton, Menu, MenuProps, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, alpha, styled } from "@mui/material";
import SplitButton from '../splitbutton';
import { SplitMenuItem, DataOutput, TableDataOutput, OutputTableInfo } from "../../data/interfaces/sharedmodels";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { useEffect, useState } from "react";
import itsoService from "../../data/api/itso.service";
import magneticService from "../../data/api/magnetic.service";



export default function OutputDataList({ table,parent }: { table: OutputTableInfo,parent:string }) {

    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputNlcs; }
        else { return state.itsoReducer.selectedOutputNlcs; }
    });
    const [tables, setTables] = useState<TableDataOutput[]>([{ Fields: [], Rows: [] }]);

    useEffect(()=>{
        if(parent==='magnetic'){
            magneticService.getOutputData(table.Id,table.IsGlobal?[]: selectedNlcs.flatMap(a=>a.Id)).then((response) => {
                if(response&&response.data)
                    setTables(response.data);
            });
        }
        else{
            itsoService.getOutputData(table.Id,table.IsGlobal?[]: selectedNlcs.flatMap(a=>a.Id)).then((response) => {
                if(response&&response.data)
                    setTables(response.data);
            });
        }
    },[table,selectedNlcs]);
    return (
        <Box>
            {!table.IsGlobal&&selectedNlcs.length<1?<Typography>Please select atleast 1 station to see the data.</Typography>:null}
            { tables.filter(a=>a.Rows.length>0).map((data,index) => {
                return (
                    <Accordion key={'out_table'+index}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                    >
                      <Typography>Table {index+1}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="output table">
                            <TableHead>
                                <TableRow>
                                    {
                                        data.Fields.map((field,fieldIndex) => {
                                            return (
                                                <TableCell key={field.Name+fieldIndex}>{field.Name}</TableCell>
                                            )
                                        })
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {

                                    data.Rows.map((row, rowIndex) => {
                                        return (
                                            <TableRow
                                                key={row.Attributes[0].Name + rowIndex}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                {
                                                    data.Fields.map((field, colIndex) => {
                                                        //return (
                                                            return (
                                                                <TableCell key={row.Attributes[colIndex].Name + index+rowIndex + colIndex}>
                                                            {field.Type === 'checkbox'?<Checkbox size="small" sx={{ width: '100%' }}  checked={row.Attributes[colIndex].Value}  /> 
                                                            :row.Attributes[colIndex].Value}</TableCell>
                                                            
                                                            
                                                        )
                                                    })
                                                
                                                }

                                            </TableRow>
                                        )
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                )
            })

            }

        </Box>
    )
}
